var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('UIActionEntity', {
    attrs: {
      "get": _vm.$api.review.addReview
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var _vm$product$price$com, _vm$product, _vm$product$price;

        var get = _ref.get,
            error = _ref.error,
            loading = _ref.loading,
            success = _ref.success,
            response = _ref.response;
        return [_c('OrderReview', {
          attrs: {
            "product": _vm.product,
            "product-price": (_vm$product$price$com = (_vm$product = _vm.product) === null || _vm$product === void 0 ? void 0 : (_vm$product$price = _vm$product.price) === null || _vm$product$price === void 0 ? void 0 : _vm$product$price.common.value) !== null && _vm$product$price$com !== void 0 ? _vm$product$price$com : 0,
            "load-error": _vm.loadError,
            "success": success,
            "loading": loading,
            "error": error,
            "review-response": response
          },
          on: {
            "send": function ($event) {
              return _vm.send(get, $event);
            }
          }
        })];
      }
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }